// Menus are portalled so they aren't clipped by the editor's containers.
// Inside a MUI dialog they must stay within it, or the dialog's focus trap
// pulls focus back out of inputs such as the link and media URL fields.
export const getPortalContainer = editor => (
  editor.view.dom.closest('.MuiDialog-root') || document.body
)
